import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'app-perfil-shell',
  templateUrl: './perfil-shell.component.html',
  styleUrls: ['./perfil-shell.component.scss'],
  standalone: false,
})
export class PerfilShellComponent {
  @Input() userName = '';
  @Input() showGreeting = true;
  /** Burbujas home (pueden ir sin saludo, p. ej. ofertas). */
  @Input() showBubbles = false;
  /** Monedas + variantes de burbujas solo para landing alianza (no otras pantallas). */
  @Input() showCoins = false;
  @Input() subtitle = '';
  /** CTA del bloque saludo (Figma: botón a la derecha del nombre). */
  @Input() ctaLabel = '';
  @Input() ctaDisabled = false;
  
  @Input() showSecurityBanner = false;
  /**
   * TEMPORAL QA: evita CMS/back en footer del sitio (no dispara mantenimiento).
   */
  @Input() skipFooterCms = false;
  @Input() hideSiteFooter = false;
  @Input() stickyHeader = false;
  @Input() compactBody = false;
  /**
   * Pantallas de sección (sobre-ti / negocio / solicita):
   * header + contenido con scroll interno + footer de sección fijo.
   */
  @Input()
  @HostBinding('class.perfil-shell-host--section-viewport')
  sectionViewport = false;

  @Output() ctaClick = new EventEmitter<void>();

  onCtaClick(): void {
    if (!this.ctaDisabled) {
      this.ctaClick.emit();
    }
  }
}
